import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BranchCardComponent } from "../branch-card/branch-card.component";
import { Router, ActivatedRoute } from '@angular/router';
import { BenefitsService } from '../../../services/benefits.service';
import { MatIcon } from '@angular/material/icon';
import { LoaderService } from '../../../../../shared/services/loader.service';

@Component({
  selector: 'app-benefist-info',
  imports: [CommonModule, BranchCardComponent, MatIcon],
  templateUrl: './benefist-info.component.html',
  styleUrl: './benefist-info.component.scss'
})
export class BenefistInfoComponent implements OnInit {
  sucursales: any[] = [];
  marcaInfo: any = null;
  currentSucursalIndex = 0;
  @ViewChild('sucursalContainer') sucursalContainer!: ElementRef<HTMLElement>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private benefitsService: BenefitsService,
    private loader: LoaderService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const idMarca = params['idMarca'];
      if (idMarca) {
        this.loader.show();
        this.benefitsService.getSucursales(Number(idMarca)).subscribe({
          next: (response) => {
            console.log('Respuesta completa:', response);
            this.marcaInfo = response.data.Marcas[0];
            this.sucursales = response.data.Marcas[0].Sucursales;
            this.loader.hide();
          },
          error: (error) => {
            console.error('Error fetching sucursales:', error);
            this.loader.hide();
          }
        });
      }
    });
  }

  goToBranches() {
    const idMarca = this.marcaInfo?.id_marca;
    this.router.navigate(['/branchs'], { queryParams: { idMarca } });
  }

  // Métodos para navegación de sucursales
  scrollSucursalLeft(): void {
    if (this.currentSucursalIndex > 0) {
      this.currentSucursalIndex--;
      this.scrollToSucursal();
    }
  }

  scrollSucursalRight(): void {
    const maxIndex = this.sucursales.length - 1;
    if (this.currentSucursalIndex < maxIndex) {
      this.currentSucursalIndex++;
      this.scrollToSucursal();
    }
  }

  private scrollToSucursal(): void {
    if (this.sucursalContainer) {
      const cardWidth = 300;
      this.sucursalContainer.nativeElement.scrollTo({
        left: this.currentSucursalIndex * cardWidth,
        behavior: 'smooth'
      });
    }
  }

  get canScrollSucursalLeft(): boolean {
    return this.currentSucursalIndex > 0;
  }

  get canScrollSucursalRight(): boolean {
    return this.currentSucursalIndex < this.sucursales.length - 1;
  }

}
